<template>
    <div>
        <my-form
        class="form-page"
        v-model="form"
        table
        label-width="160px"
        @cancle="cancleHandler"
        :submit-url="`${getGetters('bidUrl')}/newpingbiao/pbwyh/zjpj.json`">

            <el-form-item
            label="专家名称">
                {{form.zjname}}
            </el-form-item>
            <el-form-item
            label="工作单位">
                {{form.e_gzdw}}
            </el-form-item>
           
            <el-form-item
            label="任评标委员会">
                {{form.e_pwhzw}}
            </el-form-item>
            <el-form-item
            label="业务水平"
            prop="ywsp"
            :rules="newRule('业务水平', 'required')">
                <my-select
                    v-model="form.ywsp"
                    :data="[{key:'优', value:'优'}, {key:'好', value:'好'}, {key:'良', value:'良'}, {key:'差', value:'差'}, {key:'不及格', value:'不及格'}]"
                ></my-select>
            </el-form-item>

            <el-form-item
            label="优点"
            prop="youdiancode"
            :rules="newRule('优点', 'required')">
                <my-select
                    v-model="form.youdiancode"
                    :data="youdian"
                    2way="dicname"
                    :dicname.sync="form.youdiantext"
                    :props="{value:'diccode',label:'dicname'}"
                ></my-select>    
            </el-form-item>            
            <el-form-item
            label="不足"
            prop="buzucode"
            :rules="newRule('不足', 'required')">
                <my-select
                    v-model="form.buzucode"
                    :data="buzu"
                    2way="dicname"
                    :dicname.sync="form.buzutext"
                    :props="{value:'diccode',label:'dicname'}"
                ></my-select>
            </el-form-item>
            
            <el-form-item
            label="评标过程中违规违纪行为"
            prop="wjxwcode"
            :rules="newRule('评标过程中违规违纪行为', 'required')">
                <my-select
                    v-model="form.wjxwcode"
                    :data="wjxw"
                    2way="dicname"
                    :dicname.sync="form.wjxwtext"
                    :props="{value:'diccode',label:'dicname'}"
                ></my-select>
            </el-form-item>
            <el-form-item
            label="表现评价打分"
            prop="fenshu"
            :rules="newRule('表现评价打分', 'required')">
                <el-input-number
                    v-model="form.fenshu">
                </el-input-number>
            </el-form-item>

            <el-form-item
            label="表现评价文字表述"
            class="table-full-row"
            prop="pjxs"
            :rules="newRule('表现评价文字表述', 'required')">
                <el-input
                v-model="form.pjxs"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 10}"></el-input>
            </el-form-item>
                 
            <template slot="btn" slot-scope="scope">
                <el-button
                @click="saveHandler(1, scope.submitHandler)"
                type="primary"
                icon="el-icon-circle-check">
                    保存
                </el-button>
                <el-button
                @click="saveHandler(0, scope.submitHandler)"
                type="warning"
                icon="el-icon-remove-outline">
                    暂存
                </el-button>
                <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
            </template>
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import DIALOG_FORM_PAGE_MIXIN from '@views/mixins/dialog-form-page'
import MODEL_MIXIN from '@/mixins/model'

export default {
    mixins: [ MODEL_MIXIN, FORM_PAGE_MIXIN, DIALOG_FORM_PAGE_MIXIN ],
    components: { },
    props: {
        youdian: {
            type: Array,
            default: () => []
        },
        buzu: {
            type: Array,
            default: () => []
        },         
        wjxw: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({

    }),
    computed: {
        form: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        saveHandler(type, cb) {
            this.form.shbj = type;
            cb && cb();
        },
        submitHandler:function(){
            var that=this
            
            that.$post(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/zjpj.json`,this.form, (data, res) => {
                if (res.result) {
                    ShowMsg(res.msg,'success')
                    that.goto({
                        path:'./list'
                    })
                } else {
                    ShowMsg(res.msg)
                }
            });
        },
        cancleHandler() {
            this.$emit('close');
        }
    },
    created() {
     
    }
}
</script>

<style scoped lang="scss">

</style>
